import { render, staticRenderFns } from "./OnboardingImportInstanceSetupCompleteModal.vue?vue&type=template&id=1c8db0ea&scoped=true"
import script from "./OnboardingImportInstanceSetupCompleteModal.vue?vue&type=script&lang=js"
export * from "./OnboardingImportInstanceSetupCompleteModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImportInstanceSetupCompleteModal.vue?vue&type=style&index=0&id=1c8db0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8db0ea",
  null
  
)

export default component.exports